import screenLock from './lockscreen.js';


const jQ = jQuery.noConflict();

class toggleMenus{

    constructor(selector){
        this.sel = selector;
        this.mainMenu = ".main-menu";
        this.headerMain = ".header-main";
        this.body = "body";
        this.headerChecker = ".header-checker";
        this.headerMain = jQ('.header-main');
    }
    toggleTheMenu(){
        if(this.headerMain.hasClass("menu-open")) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }
    closeMenu(){
        jQ(this.headerMain).removeClass("menu-open");
        jQ(this.sel).removeClass("hamburger--open");
        jQ(this.body).removeClass("no-scroll");
        screenLock.unlock();
    }
    openMenu(){
        jQ(this.headerMain).addClass("menu-open");
        jQ(this.sel).addClass("hamburger--open");
        jQ(this.body).addClass("no-scroll");
        screenLock.lock();
    }

    init(){
        jQ(this.sel).on("click", () => {
            this.toggleTheMenu();
        });
    }
}

const toggleMenu = new toggleMenus(".hamburger");

export default toggleMenu;



// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/togglemenu.js